import React,{ Suspense }  from 'react'
import ReactDOM from 'react-dom'
import "custom/styles/color_variable.css"
import "custom/styles/image.css"
import Modal from 'react-modal'
import { Provider } from 'react-redux'
import { ModalProvider } from 'react-modal-hook'
import { I18nextProvider } from 'react-i18next'
import { PersistGate } from 'redux-persist/integration/react'
import { store, persistor } from './store'
import i18n from './i18n'

import { withOrientationChange } from 'react-device-detect'
import { ToastContainer} from 'react-toastify'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-input-range/lib/css/index.css'
import 'react-accessible-accordion/dist/fancy-example.css'

import './styles/typography.css'
import './styles/utilities.css'
import './styles/buttons.css'
import './styles/colors.css'
import './styles/inputs.css'
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import './index.css'

import App from './App'

Modal.setAppElement('#root')

ReactDOM.render(
  <I18nextProvider i18n={i18n}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ModalProvider>
          <div className='h-100'>
            <Suspense fallback='loading'>
              <App />
              <ToastContainer
                closeOnClick
                className='toast-container'
                progressClassName='progress-toast'
              />
            </Suspense>
          </div>
        </ModalProvider>
      </PersistGate>
    </Provider>
  </I18nextProvider>,
  document.getElementById('root'),
)
